module.exports = __webpack_public_path__ + "static/base_logo-b1637635bbc7258fc9d1c710373da570.png";